unit MaBstEdit;

interface

uses System.SysUtils, System.Classes, JS, Web, WebBasis, WEBLib.Graphics, WEBLib.Controls, XData.Web.Client,
     WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB,
     XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, VCL.TMSFNCTypes,
     VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.Grids,
     Vcl.Grids, WEBLib.DBCtrls, WEBLib.DB, System.StrUtils;

[async] function DoMaBstEdit( var aID_MaBst : Integer ) : TModalResult; async;


type
  TfrmMaBstEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbMaBstCaption: TLabel;
    lbEntladung: TLabel;
    edtMaBstRef: TLabel;
    lbMitarbeiter: TLabel;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    WebPanel2: TPanel;
    WebLabel4: TLabel;
    lbStatus: TLabel;
    WebLabel3: TLabel;
    WebLabel1: TLabel;
    lbDatum: TLabel;
    WebLabel2: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    mBezeichnung: TMemo;
    cbxStandort: TComboBox;
    btnPosIns: TTMSFNCToolBarButton;
    btnPosDel: TTMSFNCToolBarButton;
    WebPanel3: TPanel;
    grdMaBstPos: TDBGrid;
    btnPosMenge: TTMSFNCToolBarButton;
    btnPosMngUpd: TTMSFNCToolBarButton;
    btnPosMngDown: TTMSFNCToolBarButton;
    tabMaBstPos: TXDataWebDataSet;
    tabMaBstPosID_MA_BST: TStringField;
    tabMaBstPosID_MA_BSTPOS: TStringField;
    tabMaBstPosPOS: TStringField;
    tabMaBstPosMENGE: TStringField;
    tabMaBstPosEINHEIT: TStringField;
    tabMaBstPosBSTPOS_BEZ: TStringField;
    tabMaBstPosINS_AM: TStringField;
    dsMaBstPos: TDataSource;
    procedure btnAbbrechenClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure tabMaBstPosAfterScroll(DataSet: TDataSet);

     //
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure Daten_Laden; async;
    [async] function  Daten_Speichern : Integer; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure btnPosInsClick(Sender: TObject); async;
    [async] procedure btnPosDelClick(Sender: TObject); async;
    [async] procedure btnPosMengeClick(Sender: TObject); async;
     //


  private
    iID_MaBst  : Integer;
    iID_Akt  : Integer;
    sIDMandLand : String;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public

  protected procedure LoadDFMValues; override; end;

var frmMaBstEdit: TfrmMaBstEdit;

implementation

{$R *.dfm}

uses UnitMain, Konstanten, SpediFucsDatenmodul , GlobalWeb , GetStammdaten;

//====================================================================================================================//

function DoMaBstEdit( var aID_MaBst : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmMaBstEdit := TfrmMaBstEdit.Create(application);
  frmMaBstEdit.Popup   := True;
  frmMaBstEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmMaBstEdit.iID_MaBst  := aID_MaBst;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmMaBstEdit, frmMaBstEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow


  frmMaBstEdit.Resize;


  Try
    await( TModalResult, frmMaBstEdit.Execute);  // excute form and wait for close

    Result := frmMaBstEdit.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
        await( frmMaBstEdit.Daten_Speichern );
        aID_MaBst := frmMaBstEdit.iID_MaBst;
      End;
//
  Finally
    frmMaBstEdit.Free;
  End;


  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.Opt_Speichern;
begin

  //TWebLocalStorage.SetValue( cFormSchadenEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.Opt_Laden;
begin
 //  pgContr.ActivePageIndex := StrToIntDef( TWebLocalStorage.GetValue( cFormSchadenEdit+'PAGE' )  ,0);

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sMng, sEnh, sText : String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop, iID_Standort : Integer;
    aGuiObj :  TCoreGuiObj;
    aItem : TResponsiveGridItem;
begin

  If not WaitMessage.Showing then WaitMessage.Show;


  sSQL := '01:SELECT ID_MA_BST, REF_NR, DATUM, BEZEICHNUNG, ID_STANDORT,  '
         +' (SELECT BEZEICHNUNG FROM STATUS ST WHERE ST.ID_STATUS=B.ID_STATUS) as STATUS, '
         +' (SELECT A.NAME1 FROM STANDORT S, ADRESSE A WHERE S.ID_ADRESSE=A.ID_ADRESSE AND S.ID_STANDORT=B.ID_STANDORT) as STANDORT '
         +' FROM MA_BST B WHERE ID_MA_BST='+ IntToStr( self.iID_MaBst ) +';'

        +'02:SELECT ID_STANDORT, NAME1  FROM STANDORT S, ADRESSE A '
        +'   WHERE S.ID_ADRESSE=A.ID_ADRESSE  AND MA_BST_ABH=1 ORDER BY NAME1 ' +';'

        +'03:SELECT P.ID_MA_BST, P.ID_MA_BSTPOS, POS, MENGE, BSTPOS_BEZ, INS_AM, '
        +'  (SELECT BEZ_KURZ FROM ENH E WHERE P.ID_ENH=E.ID_ENH) as EINHEIT '
        +'  FROM MA_BSTPOS P WHERE ID_MA_BST=' + IntToStr( self.iID_MaBst ) + ' ORDER BY POS '  +';'
        ;



  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  lbMitarbeiter.Caption := frmMainForm.BenutzerMaZuname+', '+frmMainForm.BenutzerMaVorname;


  // Standorte lesen --------------------------------------------------------------------------
  cbxStandort.Items.Clear;
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '02');
  sFelder := aSL[1];
  If iAnz>2 then
  For i := 2 to aSL.Count -1 Do
    Begin
       sDaten := aSL[i];

       aGuiObj :=  TCoreGuiObj.Create;
       aGuiObj.ID := StrToIntDef( GetFeldWert( sFelder, sDaten, 'ID_STANDORT'), 0 );
       aGuiObj.Bezeichnung := GetFeldWert( sFelder, sDaten, 'NAME1'  );
       cbxStandort.Items.AddObject( aGuiObj.Bezeichnung, aGuiObj );

    End;


  // Schaden ---------------------------------------------------------
  //
  If self.iID_MaBst = 0 then
    Begin
      lbMaBstCaption.Caption := 'Material-Bestellung anlegen...';
      lbDatum.Caption := FormatDateTime('dd.mm.yyyy',Date);

      edtMaBstRef.Caption := '';
      lbStatus.Caption := '';
      mBezeichnung.Lines.Clear;

    End
  Else
    Begin
      lbMaBstCaption.Caption := 'Material-Bestellung bearbeiten...';

      iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');
      sFelder := aSL[1];
      sDaten  := aSL[2];

      edtMaBstRef.Caption := GetFeldWert( sFelder, sDaten, 'REF_NR'  );
      lbDatum.Caption     := GetFeldWert( sFelder, sDaten, 'DATUM'  );
      lbStatus.Caption    := GetFeldWert( sFelder, sDaten, 'STATUS'  );

      sTmp := GetFeldWert( sFelder, sDaten, 'BEZEICHNUNG'  );
      mBezeichnung.Text := ReplaceStr( sTmp, '##', chr(13)+chr(10) );

      iID_Standort := StrToIntDef( GetFeldWert( sFelder, sDaten, 'ID_STANDORT') , 0);
      If iID_Standort > 0 then
        For i := 0 to cbxStandort.Items.Count-1 Do
          If TCoreGuiObj(cbxStandort.Items.Objects[i]).ID = iID_Standort then
            Begin
              cbxStandort.ItemIndex := i;
              Break;
            End;
    End;



  // Bestell-Positionen -----------------------------------------------------
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '03');
  sFelder := aSL[1];

  tabMaBstPos.Close;
  tabMaBstPos.Open;

  If iAnz>2 then
  For i := 2 to aSL.Count -1 Do
    Begin
      sDaten := aSL[i];
      tabMaBstPos.Append;
      tabMaBstPos.FieldByName('ID_MA_BST').AsString    := GetFeldWert( sFelder, sDaten, 'ID_MA_BST' );
      tabMaBstPos.FieldByName('ID_MA_BSTPOS').AsString := GetFeldWert( sFelder, sDaten, 'ID_MA_BSTPOS' );
      tabMaBstPos.FieldByName('POS').AsString          := GetFeldWert( sFelder, sDaten, 'POS' ) ;
      tabMaBstPos.FieldByName('MENGE').AsString        := GetFeldWert( sFelder, sDaten, 'MENGE' ) ;
      tabMaBstPos.FieldByName('EINHEIT').AsString      := GetFeldWert( sFelder, sDaten, 'EINHEIT' ) ;
      tabMaBstPos.FieldByName('BSTPOS_BEZ').AsString   := GetFeldWert( sFelder, sDaten, 'BSTPOS_BEZ' ) ;
      tabMaBstPos.FieldByName('INS_AM').AsString       := GetFeldWert( sFelder, sDaten, 'INS_AM' ) ;
      tabMaBstPos.Post;
    End;

  tabMaBstPos.First;
  console.log('iID_Akt = '+inttostr(iID_Akt) );
  If iID_Akt > 0 then
   Begin
    If not tabMaBstPos.Locate('ID_MA_BSTPOS', IntToStr(iID_Akt), []) then tabMaBstPos.First;
    console.log('gesucht...');
   End;

  grdMaBstPos.Columns[0].Alignment := taCenter;
  grdMaBstPos.Columns[1].Alignment := taCenter;
  grdMaBstPos.Columns[2].Alignment := taCenter;
  grdMaBstPos.Columns[3].Alignment := taLeftJustify;
  grdMaBstPos.Refresh;


  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  console.log('TfrmMaBstEdit.Daten_Laden - Ende '+IntToStr(self.iID_MaBst) );

end;

//====================================================================================================================//

function TfrmMaBstEdit.Daten_Speichern : Integer;
var Response : TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sSQL, sBezeich : String;
    aObj : TParam;
    iErg, iID_Standort : Integer;
begin


  If self.iID_MaBst=0 then
    Begin
      aObj := TParam.Create;
      aObj.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr,0);
      aObj.Datum1 := Date;
      aObj.String1 := frmMainForm.User_Account;

       ClientConn := TXDataWebClient.Create(nil);
       ClientConn.Connection := frmMainForm.XDataConn;

       Response := await( ClientConn.RawInvokeAsync('ISystemService.MaBstIns', [ aObj] ));

       iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

       self.iID_MaBst := iErg;

      ClientConn.Free;

      console.log('angelegt...' +Inttostr(self.iID_MaBst)   );

    End;

  sBezeich := mBezeichnung.Text;

  iID_Standort :=  TCoreGuiObj(cbxStandort.Items.Objects[cbxStandort.ItemIndex]).ID;

  sSQL := 'UPDATE MA_BST SET '
        +' BEZEICHNUNG = '+cH+sBezeich+cH  +', '
        +' ID_STANDORT='+IntToStr(iID_Standort)
        +' WHERE ID_MA_BST='+IntToStr(self.iID_MaBst)
        +';' ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  sSQL := await( Crypt( sSQL ));

  Response := await( ClientConn.RawInvokeAsync('ISystemService.SetDatenPaket', [ sSQL ] ) );
  Blob := Response.Result;

  ClientConn.Free;

  console.log(sSQL + 'upgedatet...');

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.btnAbbrechenClick(Sender: TObject);
begin
  inherited;
  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;
end;

//====================================================================================================================//

procedure TfrmMaBstEdit.btnPosDelClick(Sender: TObject);
var iID : Integer;
    aWebParam : TParam;
    res: TModalResult;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
begin
  inherited;

  iID := tabMaBstPosID_MA_BSTPOS.AsInteger;

  If iID=0 then Exit;

  res := await(TModalResult, MessageDlgAsync('Position löschen ?', mtConfirmation, [mbYes, mbNo]));
  If res <> mrYes then Exit;

 //     sSQL := 'DELETE FROM '+aWebParam.Tabelle+' WHERE '+aWebParam.String1+' = ' +aWebParam.String2;
  btnPosMenge.Text := '0';

  aWebParam := TParam.Create;
  aWebParam.Tabelle := 'MA_BSTPOS';
  aWebParam.String1 := 'ID_MA_BSTPOS';
  aWebParam.String2 := IntToStr(iID);

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.DeleteRecord', [ aWebParam ] ));
  ClientConn.Free;

  aWebParam.Free;

  await( Daten_Laden );

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.btnPosInsClick(Sender: TObject);
var iID, iTab : Integer;
    sBez : String;
    aObj : TParam;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
begin
  inherited;

  If self.iID_MaBst=0 then  await( Daten_Speichern);

  iTab := c_Teil;
  sBez := '';
  iID := 0;

  Try
    await( Get_Stammdaten( iTab, iID, sBez ) );
  Finally
    If iID <> 0 then
      Begin
        aObj := TParam.Create;
        aObj.Integer1  := self.iID_MaBst ;
        aObj.Integer2  := iID;
        aObj.String1 := frmMainForm.User_Account;

        ClientConn := TXDataWebClient.Create(nil);
        ClientConn.Connection := frmMainForm.XDataConn;
          Response := await( ClientConn.RawInvokeAsync('ISystemService.MaBstPosIns', [ aObj ] ));
        ClientConn.Free;

        aObj.Free;

        iID_Akt := JS.ToInteger(TJSObject(Response.Result)['value']);

        await( Daten_Laden );
      End;
  End;

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.btnPosMengeClick(Sender: TObject);
var aResult : TModalResult;
    sWert, sSQL : String;
    dWert : Double;
    iID : Integer;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
begin
  inherited;

  iID := tabMaBstPosID_MA_BSTPOS.AsInteger;

  If iID=0 then Exit;


  iID_Akt := tabMaBstPosID_MA_BSTPOS.AsInteger;

  sWert := tabMaBstPosMENGE.AsString;

  If Trim(sWert)='' then sWert := '1';

  dWert := StrToFloatDef( sWert,1 );


  If Sender = btnPosMngDown then
    Begin
      dWert := dWert +1;
      aResult := mrOK;
    End;

  If Sender = btnPosMngUpd then
    Begin
      dWert := dWert -1;
      If dWert <= 0 then dWert := 1;
      aResult := mrOK;
    End;

  If Sender = btnPosMenge then
    Begin
      aResult := await(TModalResult, InputMessageDlgAsync('Menge:',mtInformation, [mbOK, mbCancel], sWert, itText));
    End
  Else sWert := FloatToStr(dWert);

  sWert := StringReplace(sWert, ',', '.', [rfReplaceAll]);

  If aResult = mrOK then
      Begin
        sSQL := 'UPDATE MA_BSTPOS SET MENGE= '+sWert+ ' WHERE ID_MA_BSTPOS='+IntToStr(iID);

        sSQL := await(  Crypt( sSQL ) );

        ClientConn := TXDataWebClient.Create(nil);
        ClientConn.Connection := frmMainForm.XDataConn;
          Response := await( ClientConn.RawInvokeAsync('ISystemService.ExecSQL', [ sSQL ] ));
        ClientConn.Free;

        await( Daten_Laden );

      End;

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.tabMaBstPosAfterScroll(DataSet: TDataSet);
begin
  inherited;
  btnPosMenge.Text := tabMaBstPosMENGE.AsString;
end;

//====================================================================================================================//

procedure TfrmMaBstEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  inherited;
  Opt_Speichern;
end;

//====================================================================================================================//

procedure TfrmMaBstEdit.WebFormCreate(Sender: TObject);
begin
  inherited;
  iID_Akt := 0;
  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.WebFormResize(Sender: TObject);
begin
  inherited;
  Form_Anpassen;
end;

//====================================================================================================================//

procedure TfrmMaBstEdit.WebFormShow(Sender: TObject);
begin
  inherited;

  WaitMessage.Show;

  Sprach_Daten_Laden('MABSTEDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;

  Inherited;

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;

  // Komponenten
  iZielBreite := Trunc( self.Width * 0.95 );
  If iZielBreite > 500 then iZielBreite := 500;

  lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

end;

//====================================================================================================================//

procedure TfrmMaBstEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmSchadenEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmSchadenEdit');

//  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbNummer.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;


 self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmMaBstEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbMaBstCaption := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  edtMaBstRef := TLabel.Create(Self);
  lbMitarbeiter := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  lbStatus := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  lbDatum := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  mBezeichnung := TMemo.Create(Self);
  cbxStandort := TComboBox.Create(Self);
  btnPosIns := TTMSFNCToolBarButton.Create(Self);
  btnPosDel := TTMSFNCToolBarButton.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  grdMaBstPos := TDBGrid.Create(Self);
  btnPosMenge := TTMSFNCToolBarButton.Create(Self);
  btnPosMngUpd := TTMSFNCToolBarButton.Create(Self);
  btnPosMngDown := TTMSFNCToolBarButton.Create(Self);
  tabMaBstPos := TXDataWebDataSet.Create(Self);
  tabMaBstPosID_MA_BST := TStringField.Create(Self);
  tabMaBstPosID_MA_BSTPOS := TStringField.Create(Self);
  tabMaBstPosPOS := TStringField.Create(Self);
  tabMaBstPosMENGE := TStringField.Create(Self);
  tabMaBstPosEINHEIT := TStringField.Create(Self);
  tabMaBstPosBSTPOS_BEZ := TStringField.Create(Self);
  tabMaBstPosINS_AM := TStringField.Create(Self);
  dsMaBstPos := TDataSource.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbMaBstCaption.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  edtMaBstRef.BeforeLoadDFMValues;
  lbMitarbeiter.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  lbStatus.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  lbDatum.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  mBezeichnung.BeforeLoadDFMValues;
  cbxStandort.BeforeLoadDFMValues;
  btnPosIns.BeforeLoadDFMValues;
  btnPosDel.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  grdMaBstPos.BeforeLoadDFMValues;
  btnPosMenge.BeforeLoadDFMValues;
  btnPosMngUpd.BeforeLoadDFMValues;
  btnPosMngDown.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabMaBstPos.BeforeLoadDFMValues;
  tabMaBstPosID_MA_BST.BeforeLoadDFMValues;
  tabMaBstPosID_MA_BSTPOS.BeforeLoadDFMValues;
  tabMaBstPosPOS.BeforeLoadDFMValues;
  tabMaBstPosMENGE.BeforeLoadDFMValues;
  tabMaBstPosEINHEIT.BeforeLoadDFMValues;
  tabMaBstPosBSTPOS_BEZ.BeforeLoadDFMValues;
  tabMaBstPosINS_AM.BeforeLoadDFMValues;
  dsMaBstPos.BeforeLoadDFMValues;
  try
    Width := 580;
    Height := 634;
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WaitMessage.Left := 395;
    WaitMessage.Top := 164;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 580;
    WebPanel1.Height := 84;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 2;
    lbMaBstCaption.SetParentComponent(WebPanel1);
    lbMaBstCaption.Name := 'lbMaBstCaption';
    lbMaBstCaption.Left := 157;
    lbMaBstCaption.Top := 5;
    lbMaBstCaption.Width := 158;
    lbMaBstCaption.Height := 18;
    lbMaBstCaption.Caption := 'Material-Bestellung';
    lbMaBstCaption.Font.Charset := DEFAULT_CHARSET;
    lbMaBstCaption.Font.Color := clBlack;
    lbMaBstCaption.Font.Height := -15;
    lbMaBstCaption.Font.Name := 'Verdana';
    lbMaBstCaption.Font.Style := [fsBold];
    lbMaBstCaption.HeightPercent := 100.000000000000000000;
    lbMaBstCaption.ParentFont := False;
    lbMaBstCaption.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 57;
    lbEntladung.Width := 71;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Mitarbeiter';
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.WidthPercent := 100.000000000000000000;
    edtMaBstRef.SetParentComponent(WebPanel1);
    edtMaBstRef.Name := 'edtMaBstRef';
    edtMaBstRef.Left := 157;
    edtMaBstRef.Top := 29;
    edtMaBstRef.Width := 88;
    edtMaBstRef.Height := 18;
    edtMaBstRef.Caption := 'S0000000';
    edtMaBstRef.Font.Charset := ANSI_CHARSET;
    edtMaBstRef.Font.Color := clWindowText;
    edtMaBstRef.Font.Height := -15;
    edtMaBstRef.Font.Name := 'Verdana';
    edtMaBstRef.Font.Style := [fsBold];
    edtMaBstRef.HeightPercent := 100.000000000000000000;
    edtMaBstRef.ParentFont := False;
    edtMaBstRef.WidthPercent := 100.000000000000000000;
    lbMitarbeiter.SetParentComponent(WebPanel1);
    lbMitarbeiter.Name := 'lbMitarbeiter';
    lbMitarbeiter.Left := 106;
    lbMitarbeiter.Top := 57;
    lbMitarbeiter.Width := 71;
    lbMitarbeiter.Height := 16;
    lbMitarbeiter.Caption := 'T0000000';
    lbMitarbeiter.Font.Charset := ANSI_CHARSET;
    lbMitarbeiter.Font.Color := clWindowText;
    lbMitarbeiter.Font.Height := -13;
    lbMitarbeiter.Font.Name := 'Verdana';
    lbMitarbeiter.Font.Style := [fsBold];
    lbMitarbeiter.HeightPercent := 100.000000000000000000;
    lbMitarbeiter.ParentFont := False;
    lbMitarbeiter.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 74;
    btnOK.Top := 5;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnAbbrechenClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnAbbrechenClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 84;
    WebPanel2.Width := 580;
    WebPanel2.Height := 550;
    WebPanel2.Align := alClient;
    WebPanel2.ChildOrder := 11;
    WebPanel2.Color := 16776441;
    WebPanel2.TabOrder := 3;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 107;
    WebLabel4.Width := 82;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Bezeichnung';
    WebLabel4.Color := 16776441;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    lbStatus.SetParentComponent(WebPanel2);
    lbStatus.Name := 'lbStatus';
    lbStatus.Left := 90;
    lbStatus.Top := 38;
    lbStatus.Width := 65;
    lbStatus.Height := 16;
    lbStatus.Caption := 'Angelegt';
    lbStatus.Color := 16776441;
    lbStatus.Font.Charset := ANSI_CHARSET;
    lbStatus.Font.Color := clWindowText;
    lbStatus.Font.Height := -13;
    lbStatus.Font.Name := 'Verdana';
    lbStatus.Font.Style := [fsBold];
    lbStatus.HeightPercent := 100.000000000000000000;
    lbStatus.ParentFont := False;
    lbStatus.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 37;
    WebLabel3.Width := 50;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Status:';
    WebLabel3.Color := 16776441;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 16;
    WebLabel1.Width := 48;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Datum:';
    WebLabel1.Color := 16776441;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    lbDatum.SetParentComponent(WebPanel2);
    lbDatum.Name := 'lbDatum';
    lbDatum.Left := 90;
    lbDatum.Top := 16;
    lbDatum.Width := 82;
    lbDatum.Height := 16;
    lbDatum.Caption := '07.08.2025';
    lbDatum.Color := 16776441;
    lbDatum.Font.Charset := ANSI_CHARSET;
    lbDatum.Font.Color := clWindowText;
    lbDatum.Font.Height := -13;
    lbDatum.Font.Name := 'Verdana';
    lbDatum.Font.Style := [fsBold];
    lbDatum.HeightPercent := 100.000000000000000000;
    lbDatum.ParentFont := False;
    lbDatum.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 235;
    WebLabel2.Width := 117;
    WebLabel2.Height := 16;
    WebLabel2.Caption := 'Bestell-Positionen';
    WebLabel2.Color := 16776441;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 16;
    WebLabel5.Top := 69;
    WebLabel5.Width := 64;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'Standort:';
    WebLabel5.Color := 16776441;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 236;
    WebLabel6.Top := 235;
    WebLabel6.Width := 43;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Menge';
    WebLabel6.Color := 16776441;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    mBezeichnung.SetParentComponent(WebPanel2);
    mBezeichnung.Name := 'mBezeichnung';
    mBezeichnung.Left := 16;
    mBezeichnung.Top := 128;
    mBezeichnung.Width := 353;
    mBezeichnung.Height := 84;
    mBezeichnung.HeightPercent := 100.000000000000000000;
    mBezeichnung.SelLength := 0;
    mBezeichnung.SelStart := 0;
    mBezeichnung.WidthPercent := 100.000000000000000000;
    cbxStandort.SetParentComponent(WebPanel2);
    cbxStandort.Name := 'cbxStandort';
    cbxStandort.Left := 90;
    cbxStandort.Top := 65;
    cbxStandort.Width := 199;
    cbxStandort.Height := 24;
    cbxStandort.HeightPercent := 100.000000000000000000;
    cbxStandort.Text := 'Standort 1';
    cbxStandort.WidthPercent := 100.000000000000000000;
    cbxStandort.ItemIndex := 0;
    cbxStandort.Items.BeginUpdate;
    try
      cbxStandort.Items.Clear;
      cbxStandort.Items.Add('Standort 1');
      cbxStandort.Items.Add('Standort 2');
    finally
      cbxStandort.Items.EndUpdate;
    end;
    btnPosIns.SetParentComponent(WebPanel2);
    btnPosIns.Name := 'btnPosIns';
    btnPosIns.Left := 16;
    btnPosIns.Top := 253;
    btnPosIns.Width := 50;
    btnPosIns.Height := 40;
    btnPosIns.Cursor := crHandPoint;
    btnPosIns.ParentDoubleBuffered := False;
    btnPosIns.DoubleBuffered := True;
    btnPosIns.Font.Charset := DEFAULT_CHARSET;
    btnPosIns.Font.Color := clWindowText;
    btnPosIns.Font.Height := -11;
    btnPosIns.Font.Name := 'Segoe UI';
    btnPosIns.Font.Style := [];
    btnPosIns.ParentColor := True;
    btnPosIns.TabOrder := 2;
    SetEvent(btnPosIns, Self, 'OnClick', 'btnPosInsClick');
    btnPosIns.Text := '';
    btnPosIns.Bitmaps.Clear;
    with btnPosIns.Bitmaps.Add do
    begin
      BitmapName := 'INS';
    end;
    btnPosIns.BitmapVisible := True;
    btnPosIns.BitmapContainer := BitmapCont;
    btnPosIns.ControlIndex := 0;
    btnPosDel.SetParentComponent(WebPanel2);
    btnPosDel.Name := 'btnPosDel';
    btnPosDel.Left := 72;
    btnPosDel.Top := 253;
    btnPosDel.Width := 50;
    btnPosDel.Height := 40;
    btnPosDel.Cursor := crHandPoint;
    btnPosDel.ParentDoubleBuffered := False;
    btnPosDel.DoubleBuffered := True;
    btnPosDel.Font.Charset := ANSI_CHARSET;
    btnPosDel.Font.Color := clWindowText;
    btnPosDel.Font.Height := -13;
    btnPosDel.Font.Name := 'Verdana';
    btnPosDel.Font.Style := [];
    btnPosDel.ParentColor := True;
    btnPosDel.TabOrder := 3;
    SetEvent(btnPosDel, Self, 'OnClick', 'btnPosDelClick');
    btnPosDel.Text := '';
    btnPosDel.TextVisible := False;
    btnPosDel.Bitmaps.Clear;
    with btnPosDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnPosDel.BitmapVisible := True;
    btnPosDel.BitmapContainer := BitmapCont;
    btnPosDel.ControlIndex := 0;
    WebPanel3.SetParentComponent(WebPanel2);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 16;
    WebPanel3.Top := 223;
    WebPanel3.Width := 551;
    WebPanel3.Height := 2;
    WebPanel3.Anchors := [akLeft,akTop,akRight];
    WebPanel3.ChildOrder := 12;
    WebPanel3.TabOrder := 4;
    grdMaBstPos.SetParentComponent(WebPanel2);
    grdMaBstPos.Name := 'grdMaBstPos';
    grdMaBstPos.Left := 16;
    grdMaBstPos.Top := 299;
    grdMaBstPos.Width := 551;
    grdMaBstPos.Height := 244;
    grdMaBstPos.Cursor := crHandPoint;
    grdMaBstPos.Anchors := [akLeft,akTop,akRight,akBottom];
    grdMaBstPos.Columns.Clear;
    with grdMaBstPos.Columns.Add do
    begin
      Alignment := taCenter;
      DataField := 'POS';
      Title := 'Pos';
      Width := 36;
    end;
    with grdMaBstPos.Columns.Add do
    begin
      Alignment := taCenter;
      DataField := 'MENGE';
      Title := 'Menge';
      Width := 45;
    end;
    with grdMaBstPos.Columns.Add do
    begin
      Alignment := taCenter;
      DataField := 'EINHEIT';
      Title := 'Einheit';
      Width := 51;
    end;
    with grdMaBstPos.Columns.Add do
    begin
      DataField := 'BSTPOS_BEZ';
      Title := 'Artikel';
      Width := 215;
    end;
    grdMaBstPos.DefaultRowHeight := 40;
    grdMaBstPos.DataSource := dsMaBstPos;
    grdMaBstPos.FixedFont.Charset := ANSI_CHARSET;
    grdMaBstPos.FixedFont.Color := clWindowText;
    grdMaBstPos.FixedFont.Height := -12;
    grdMaBstPos.FixedFont.Name := 'Verdana';
    grdMaBstPos.FixedFont.Style := [];
    grdMaBstPos.FixedCols := 0;
    grdMaBstPos.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goColMoving,goRowSelect,goFixedRowDefAlign];
    grdMaBstPos.TabOrder := 5;
    grdMaBstPos.HeightPercent := 100.000000000000000000;
    grdMaBstPos.WidthPercent := 100.000000000000000000;
    grdMaBstPos.ColWidths[0] := 36;
    grdMaBstPos.ColWidths[1] := 45;
    grdMaBstPos.ColWidths[2] := 51;
    grdMaBstPos.ColWidths[3] := 215;
    btnPosMenge.SetParentComponent(WebPanel2);
    btnPosMenge.Name := 'btnPosMenge';
    btnPosMenge.Left := 233;
    btnPosMenge.Top := 253;
    btnPosMenge.Width := 50;
    btnPosMenge.Height := 40;
    btnPosMenge.Cursor := crHandPoint;
    btnPosMenge.ParentDoubleBuffered := False;
    btnPosMenge.DoubleBuffered := True;
    btnPosMenge.Font.Charset := ANSI_CHARSET;
    btnPosMenge.Font.Color := clWindowText;
    btnPosMenge.Font.Height := -13;
    btnPosMenge.Font.Name := 'Verdana';
    btnPosMenge.Font.Style := [];
    btnPosMenge.ParentColor := True;
    btnPosMenge.TabOrder := 6;
    SetEvent(btnPosMenge, Self, 'OnClick', 'btnPosMengeClick');
    btnPosMenge.Text := '1';
    btnPosMenge.BitmapContainer := BitmapCont;
    btnPosMenge.ControlIndex := 0;
    btnPosMngUpd.SetParentComponent(WebPanel2);
    btnPosMngUpd.Name := 'btnPosMngUpd';
    btnPosMngUpd.Left := 181;
    btnPosMngUpd.Top := 253;
    btnPosMngUpd.Width := 50;
    btnPosMngUpd.Height := 40;
    btnPosMngUpd.Cursor := crHandPoint;
    btnPosMngUpd.ParentDoubleBuffered := False;
    btnPosMngUpd.DoubleBuffered := True;
    btnPosMngUpd.Font.Charset := ANSI_CHARSET;
    btnPosMngUpd.Font.Color := clWindowText;
    btnPosMngUpd.Font.Height := -13;
    btnPosMngUpd.Font.Name := 'Verdana';
    btnPosMngUpd.Font.Style := [];
    btnPosMngUpd.ParentColor := True;
    btnPosMngUpd.TabOrder := 7;
    SetEvent(btnPosMngUpd, Self, 'OnClick', 'btnPosMengeClick');
    btnPosMngUpd.Text := '';
    btnPosMngUpd.TextVisible := False;
    btnPosMngUpd.Bitmaps.Clear;
    with btnPosMngUpd.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnPosMngUpd.BitmapVisible := True;
    btnPosMngUpd.BitmapContainer := BitmapCont;
    btnPosMngUpd.ControlIndex := 0;
    btnPosMngDown.SetParentComponent(WebPanel2);
    btnPosMngDown.Name := 'btnPosMngDown';
    btnPosMngDown.Left := 285;
    btnPosMngDown.Top := 253;
    btnPosMngDown.Width := 50;
    btnPosMngDown.Height := 40;
    btnPosMngDown.Cursor := crHandPoint;
    btnPosMngDown.ParentDoubleBuffered := False;
    btnPosMngDown.DoubleBuffered := True;
    btnPosMngDown.Font.Charset := ANSI_CHARSET;
    btnPosMngDown.Font.Color := clWindowText;
    btnPosMngDown.Font.Height := -13;
    btnPosMngDown.Font.Name := 'Verdana';
    btnPosMngDown.Font.Style := [];
    btnPosMngDown.ParentColor := True;
    btnPosMngDown.TabOrder := 8;
    SetEvent(btnPosMngDown, Self, 'OnClick', 'btnPosMengeClick');
    btnPosMngDown.Text := '';
    btnPosMngDown.TextVisible := False;
    btnPosMngDown.Bitmaps.Clear;
    with btnPosMngDown.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnPosMngDown.BitmapVisible := True;
    btnPosMngDown.BitmapContainer := BitmapCont;
    btnPosMngDown.ControlIndex := 0;
    tabSprachDaten.Left := 368;
    tabSprachDaten.Top := 248;
    tabMaBstPos.SetParentComponent(Self);
    tabMaBstPos.Name := 'tabMaBstPos';
    tabMaBstPos.AfterScroll := tabMaBstPosAfterScroll;
    tabMaBstPos.Left := 440;
    tabMaBstPos.Top := 400;
    tabMaBstPosID_MA_BST.SetParentComponent(tabMaBstPos);
    tabMaBstPosID_MA_BST.Name := 'tabMaBstPosID_MA_BST';
    tabMaBstPosID_MA_BST.FieldName := 'ID_MA_BST';
    tabMaBstPosID_MA_BST.Size := 10;
    tabMaBstPosID_MA_BSTPOS.SetParentComponent(tabMaBstPos);
    tabMaBstPosID_MA_BSTPOS.Name := 'tabMaBstPosID_MA_BSTPOS';
    tabMaBstPosID_MA_BSTPOS.FieldName := 'ID_MA_BSTPOS';
    tabMaBstPosID_MA_BSTPOS.Size := 10;
    tabMaBstPosPOS.SetParentComponent(tabMaBstPos);
    tabMaBstPosPOS.Name := 'tabMaBstPosPOS';
    tabMaBstPosPOS.FieldName := 'POS';
    tabMaBstPosPOS.Size := 5;
    tabMaBstPosMENGE.SetParentComponent(tabMaBstPos);
    tabMaBstPosMENGE.Name := 'tabMaBstPosMENGE';
    tabMaBstPosMENGE.FieldName := 'MENGE';
    tabMaBstPosMENGE.Size := 10;
    tabMaBstPosEINHEIT.SetParentComponent(tabMaBstPos);
    tabMaBstPosEINHEIT.Name := 'tabMaBstPosEINHEIT';
    tabMaBstPosEINHEIT.FieldName := 'EINHEIT';
    tabMaBstPosEINHEIT.Size := 5;
    tabMaBstPosBSTPOS_BEZ.SetParentComponent(tabMaBstPos);
    tabMaBstPosBSTPOS_BEZ.Name := 'tabMaBstPosBSTPOS_BEZ';
    tabMaBstPosBSTPOS_BEZ.FieldName := 'BSTPOS_BEZ';
    tabMaBstPosBSTPOS_BEZ.Size := 50;
    tabMaBstPosINS_AM.SetParentComponent(tabMaBstPos);
    tabMaBstPosINS_AM.Name := 'tabMaBstPosINS_AM';
    tabMaBstPosINS_AM.FieldName := 'INS_AM';
    dsMaBstPos.SetParentComponent(Self);
    dsMaBstPos.Name := 'dsMaBstPos';
    dsMaBstPos.DataSet := tabMaBstPos;
    dsMaBstPos.Left := 440;
    dsMaBstPos.Top := 464;
  finally
    WaitMessage.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbMaBstCaption.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    edtMaBstRef.AfterLoadDFMValues;
    lbMitarbeiter.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    lbStatus.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    lbDatum.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    mBezeichnung.AfterLoadDFMValues;
    cbxStandort.AfterLoadDFMValues;
    btnPosIns.AfterLoadDFMValues;
    btnPosDel.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    grdMaBstPos.AfterLoadDFMValues;
    btnPosMenge.AfterLoadDFMValues;
    btnPosMngUpd.AfterLoadDFMValues;
    btnPosMngDown.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabMaBstPos.AfterLoadDFMValues;
    tabMaBstPosID_MA_BST.AfterLoadDFMValues;
    tabMaBstPosID_MA_BSTPOS.AfterLoadDFMValues;
    tabMaBstPosPOS.AfterLoadDFMValues;
    tabMaBstPosMENGE.AfterLoadDFMValues;
    tabMaBstPosEINHEIT.AfterLoadDFMValues;
    tabMaBstPosBSTPOS_BEZ.AfterLoadDFMValues;
    tabMaBstPosINS_AM.AfterLoadDFMValues;
    dsMaBstPos.AfterLoadDFMValues;
  end;
end;

end.